import Link from "next/link";
import classes from "./BlogCarouselItem.module.css";
import Image from "next/image";

const BlogCarouselSelection = ({ listing, idx }) => {
  return (
    <li className={classes.itemBubble} key={idx}>
      <Link
        href={listing.href ? listing.href : `/product/${listing?.kashewId}`}
        className={classes.productLink}
      >
        <section className={classes.topSectionBubble}>
          <Image
            src={listing.images[0]}
            alt={listing.title}
            width={200}
            height={200}
            className={classes.img}
          />
        </section>

        <section className={classes.bottomSection}>
          <h3 className={classes.title}>{listing.displayText}</h3>
        </section>
      </Link>
    </li>
  );
};

export default BlogCarouselSelection;
